module.exports = __webpack_public_path__ + "media/images/symbols/calendar-93fda7840719f62cdec8b95ab1819eb0.svg";